import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Home } from './pages/Home';
import { Legal } from './pages/Legal';
import { Authenticity } from './pages/Authenticity';
import { CrewRewards } from './pages/CrewRewards';
import { Activate } from './pages/Activate';
import { Guide } from './pages/Guide';
import { TrackOrder } from './pages/TrackOrder';
import { ScrollToHash } from './components/ScrollToHash';
import { PixelRouteTracker } from './components/PixelRouteTracker';
import { SiteMeta } from './components/SiteMeta';
import { initPixels } from './utils/tracking';
type OfferId = 'single' | 'trio' | 'crew';
interface AppProps {
  showAnnouncementBar?: boolean;
  defaultOffer?: OfferId;
}
export function App({
  showAnnouncementBar = true,
  defaultOffer = 'trio'
}: AppProps) {
  // Loads the Meta Pixel once and fires PageView as soon as the site loads, on any page.
  useEffect(() => {
    initPixels();
  }, []);
  return <BrowserRouter data-id="element-0" data-mp="23ti7e2craqj5">
      <ScrollToHash data-id="element-1" data-mp="3ik7ekc2063oj" />
      <PixelRouteTracker data-id="element-2" data-mp="3ikqwhsrnks2k" />
      <SiteMeta data-id="element-3" data-mp="3ijfunyhrpue3" />
      <Routes data-id="element-4" data-mp="3ihv0wb3a2fha">
        <Route path="/" element={<Home showAnnouncementBar={showAnnouncementBar} defaultOffer={defaultOffer} data-id="element-6" data-mp="3mkhou0wtvg97" />} data-id="element-5" data-mp="3mljaezbgzl56" />
        <Route path="/verify" element={<Authenticity data-id="element-8" data-mp="3rd189ei755lx" />} data-id="element-7" data-mp="3rdarmj8qkein" />
        <Route path="/rewards" element={<CrewRewards data-id="element-10" data-mp="682rygdekbl" />} data-id="element-9" data-mp="5yhgo69t1c8" />
        <Route path="/activate" element={<Activate data-id="element-12" data-mp="2zl39tfhhuw2o" />} data-id="element-11" data-mp="5ggxfcks0yi" />
        <Route path="/guide" element={<Guide data-id="element-14" data-mp="2zmenq84nlk7i" />} data-id="element-13" data-mp="2zllduyaeeel5" />
        <Route path="/track" element={<TrackOrder data-id="element-16" data-mp="33mowfsjtyoq2" />} data-id="element-15" data-mp="2zmwh8wzxlkbq" />
        <Route path="/legal/:slug" element={<Legal data-id="element-18" data-mp="33mym1f0yqtv8" />} data-id="element-17" data-mp="33lwzadal4ixo" />
        <Route path="*" element={<Legal data-id="element-20" data-mp="38m1f013o59mu" />} data-id="element-19" data-mp="33oi2b5mmd4x0" />
      </Routes>
    </BrowserRouter>;
}